var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.className,on:{"click":function($event){return _vm.onHandle(_vm.id, _vm.pageType)}}},[_c('img',{attrs:{"src":require("@/static/icons/comment.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }